import API from '../../api/api';
import React, { Component } from 'react';
import '../../styles/css/Jobs/JobReviewCard.css';
import StarRateIcon from '@material-ui/icons/StarRate';
import ErrorOutileIcon from '@material-ui/icons/ErrorOutline';
import StarRatingComponent from 'react-star-rating-component';
import CircularProgress from '@material-ui/core/CircularProgress';

const token = localStorage.getItem('token');
const userRole = localStorage.getItem('userRole');

class JobReviewCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewComment: '',
      starValue: 0,
      isReviewd: false,
      isSending: false,
      isSubmitted: false,
    }
    this.starRate = [];
  }

  componentDidMount() {
    this.setState({
      isReviewd: this.props.review !== false ? true : false,
      starValue: this.props.review !== false ? parseInt(this.props.review.rating, 10) : 0,
      reviewComment: this.props.review !== false ? this.props.review.description : '',
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.review !== prevProps.review) {
      this.setState({
        isReviewd: this.props.review !== false ? true : false,
        starValue: this.props.review !== false ? parseInt(this.props.review.rating, 10) : 0,
      })
    }
  }

  handleInputChange = (e) => {
    this.setState({ reviewComment: e.target.value })
  }

  onStarClick(nextValue) {
    this.setState({ starValue: nextValue })
  }

  submitReview = (e) => {
    e.preventDefault();

    this.setState({ isSending: true })

    const sendReview = {
      job_id: this.props.jobId,
      rating: this.state.starValue,
      description: this.state.reviewComment,
      type: userRole === 'Surveyor' ? 'Title' : 'Survey'
    }

    if (this.state.starValue !== 0) {
      const reviewId = this.props.review === false ? "0" : this.props.review.id
      API.post('user/review/' + reviewId, sendReview)
        .then(res => {
          this.setState({ isSending: false })
          this.showCreationMessage();
          window.location.reload();
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.setState({ isSending: false })
        })
    }
    else {
      this.setState({ isSending: false })
    }
  }

  showCreationMessage = () => {
    this.setState({
      isSubmitted: true,
    })
    setTimeout(() => {
      this.setState({
        isSubmitted: false,
      })
    }, 3000);
  }

  render() {

    const { review } = this.props;
    const { isSending, isSubmitted } = this.state;

    return (
      <div className="detailCardRoot">
        <div className="detailCardMain">
          <div className="detailCardTitle">
            {
              token && token.length > 0 ?
                (userRole === 'Title Company Admin' || userRole === 'Title Company User') ?
                  <div>
                    <div className="nameMain">
                      <span>Surveyor review</span>
                    </div>
                  </div>
                  :
                  userRole === 'Surveyor' ?
                    <div>
                      <div className="nameMain">
                        <span>Title company review</span>
                      </div>
                    </div>
                    :
                    null
                : null
            }
          </div>
          <div className="detailCardDetails">
            {
              token && token.length > 0 ?
                <div>
                  <hr />
                  <div className="cardDetail">
                    <span className="starReviewSpan">Star review</span>
                    <span className="starReviewRatingSpan">
                      <StarRatingComponent
                        name="rate1"
                        starCount={5}
                        value={this.state.starValue}
                        starColor={"#9cd5f1"}
                        emptyStarColor={"#b1b1b1"}
                        renderStarIcon={() => <StarRateIcon />}
                        onStarClick={this.onStarClick.bind(this)}
                      />
                    </span>
                  </div>
                  <div className="cardDetail topMargin">
                    <span>Additional comment</span>
                  </div>
                  <div className="cardDetail">
                    <textarea
                      id="reviewComment"
                      name="reviewComment"
                      className="reviewComment"
                      value={this.state.reviewComment}
                      onChange={this.handleInputChange}
                    >
                      {review !== false && review.description}
                    </textarea>
                  </div>
                  <div className="cardDetail noFlex">
                    <div className="userCreationMessage messageResponsive" id="userCreationMessage">
                      {
                        isSubmitted &&
                        <div className="messageBody userCreationSuccessColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          {
                            review === false ?
                              <div className="userCreationSuccess">Review sent successfully!</div>
                              :
                              <div className="userCreationSuccess">Review updated successfully!</div>
                          }
                        </div>
                      }
                    </div>
                    <button className="postReviewBtn" onClick={this.submitReview}>
                      {
                        isSending ?
                          <CircularProgress className="circularColor2" />
                          :
                          review === false ?
                            <span>Post review</span>
                            :
                            <span>Update review</span>
                      }
                    </button>
                  </div>
                </div>
                :
                null
            }
          </div>
        </div>
      </div>
    )
  }
}

export default JobReviewCard;


// WEBPACK FOOTER //
// ./src/pages/Jobs/JobReviewCard.js